import type { ViewJSON } from 'balus-common';

export class ViewSetting {
  public readonly showNodeCreatedUser: boolean;
  public readonly isLocked: boolean;
  public readonly isPositionFixed: boolean;

  public constructor(showNodeCreatedUser: boolean, isLocked: boolean, isPositionFixed: boolean) {
    this.showNodeCreatedUser = showNodeCreatedUser;
    this.isLocked = isLocked;
    this.isPositionFixed = isPositionFixed;
  }

  static buildNew(): ViewSetting {
    return this.load({
      showNodeCreatedUser: false,
      isLocked: false,
      isPositionFixed: false,
    });
  }

  public dump(): ViewJSON['setting'] {
    return {
      showNodeCreatedUser: this.showNodeCreatedUser,
      isLocked: this.isLocked,
      isPositionFixed: this.isPositionFixed,
    };
  }

  public dumpWithUnlock(): ViewJSON['setting'] {
    return {
      showNodeCreatedUser: this.showNodeCreatedUser,
      isLocked: false,
      isPositionFixed: false,
    };
  }

  static load(dump: ViewJSON['setting']): ViewSetting {
    const { showNodeCreatedUser, isLocked, isPositionFixed } = dump;
    return new this(showNodeCreatedUser, isLocked, isPositionFixed);
  }

  public isEquals(other: ViewSetting): boolean {
    return (
      other instanceof ViewSetting &&
      other.showNodeCreatedUser == this.showNodeCreatedUser &&
      other.isLocked == this.isLocked &&
      other.isPositionFixed == this.isPositionFixed
    );
  }
}
